import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL — permanently redirects to keyword-first slug.
export const Route = createFileRoute("/boulder-web-design")({
  beforeLoad: () => {
    throw redirect({
      to: "/web-design-boulder-colorado",
      statusCode: 301,
    });
  },
});
